let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jjKyj")).then(() => parcelRequire('gIkZ4'));